var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-item border-bottom",staticStyle:{"padding-left":"12px"},on:{"click":function($event){return _vm.$emit('click', _vm.value)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }